import React from 'react';
import { View, Text, StyleProp, TextStyle } from 'react-native';
import { BookItem } from '../~Utilities/Constants';

/*   ====================================================================   */

interface IOBStaticStyleText
{
style?: StyleProp<TextStyle>;

getText: () => string;

color: string;

item : BookItem;

iWDelta : number;

onClick: (item : BookItem) => void;

bindEvent : (onEvent    : (() => void), 
             bSubscribe : boolean) => void;

//is_fg? : boolean;

//min_width : number;
}

/*   ====================================================================   */

export default class OBStaticStyleText extends React.Component<IOBStaticStyleText>
   {
   UpdateData()
   {
   var sNewText = this.props.getText();

   if (this.state.sText != sNewText)
      this.setState({sText: sNewText});
   }

   /*   ------------------------------------------------------------------   */
   
   constructor(props)
   {
   super(props);

   this.UpdateData = this.UpdateData.bind(this);
   this.state      = {sText:this.props.getText()}
   }

   /*   ------------------------------------------------------------------   */

   componentDidMount() 
   {
   this.props.bindEvent(this.UpdateData, true);
   }

   /*   ------------------------------------------------------------------   */

   componentWillUnmount() 
   {
   this.props.bindEvent(this.UpdateData, false);
   }

   /*   ------------------------------------------------------------------   */
   
   state = {sText: ""}

   /*   ------------------------------------------------------------------   */

   render() 
      {
      return (
      <View style={this.state.sText == ""? {minWidth: 50 - this.props.iWDelta, height:'100%', backgroundColor:'transparent',} : {minWidth: 50 - this.props.iWDelta, height:'100%', backgroundColor: this.props.color}}> 
      <Text onPress={(event)=>{this.props.onClick(this.props.item)}} style={this.props.style}> {this.state.sText} </Text>
      </View>
      );
      }
}